module.exports = new __parcel__URL__("Lawn.00c30e82.hdr").toString();